import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo.png';

const VIDEOS = [
  { file: 'ado stall sc 2025_CW.mp4',                      title: 'Adoriva Stall SC',                  year: '2025' },
  { file: 'APL Apollo roof india 2026_CW-1.mp4',            title: 'APL Apollo Roof India',              year: '2026' },
  { file: 'Ati automation exposouth 2026_CW 2.mp4',         title: 'ATI Automation ExpoSouth',           year: '2026' },
  { file: 'bharat mobility 2025 wrap up.mp4',               title: 'Bharat Mobility Wrap Up',            year: '2025' },
  { file: 'de dietrich chemtech 2026_CW 2.mp4',             title: 'De Dietrich Chemtech',               year: '2026' },
  { file: 'de dietrich chemtech 2026_CW fin-2.mp4',         title: 'De Dietrich Chemtech (Final Cut)',   year: '2026' },
  { file: 'For APL Apollo - Roof India 2026.mp4',           title: 'APL Apollo – Roof India',            year: '2026' },
  { file: 'HLE Glascoat Chempro Tech 2026_CW.mp4',          title: 'HLE Glascoat Chempro Tech',          year: '2026' },
  { file: 'LiuGong InterMat 2026_CW 2.mp4',                 title: 'LiuGong InterMat',                   year: '2026' },
  { file: 'MB phenix stall_CW_2.mp4',                       title: 'MB Phenix Stall',                    year: '2025' },
  { file: 'steel construction expo 2025 highlights_CW.mp4', title: 'Steel Construction Expo Highlights', year: '2025' },
  { file: 'steel consutruction expo feb 2026_CW 2.mp4',    title: 'Steel Construction Expo Feb',        year: '2026' },
  { file: 'zamil stall sc 2025_CW-1.mp4',                  title: 'Zamil Stall SC',                     year: '2025' },
  { file: 'Ati Robotics at IWS 2026_CW.mp4',               title: 'Ati Robotics at IWS 2026',           year: '2026', src: 'https://chalkwalkconsulting.com/Tech/Tech/Ati%20Robotics%20at%20IWS%202026_CW.mp4' },
  { file: 'APL Apollo at IWS 2026_CW.mp4',                 title: 'APL Apollo at IWS 2026',             year: '2026', src: 'https://chalkwalkconsulting.com/Tech/Tech/APL%20Apollo%20at%20IWS%202026_CW.mp4' },
  { file: 'Uhlmann at Propack 2026_CW.mp4',                title: 'Uhlmann at Propack 2026',            year: '2026', src: 'https://chalkwalkconsulting.com/Tech/Tech/Uhlmann%20at%20Propack%202026_CW.mp4' },
  { file: 'Atlas Copco at Rig Event_CW.mp4',               title: 'Atlas Copco at Rig Event',           year: '2026' },
  { file: 'Okaya at REI 2026_CW.mp4',                      title: 'Okaya at REI 2026',                  year: '2026' },
  { file: 'Boiler India 2026 - MEE_CW.mp4',                title: 'Boiler India 2026 – MEE',            year: '2026' },
];

function VideoCard({ video, index, onClick }) {
  const [hov, setHov] = useState(false);
  const src = video.src || `/Event%20Coverage/${encodeURIComponent(video.file)}`;
  const is2026 = video.year === '2026';

  return (
    <div
      onClick={() => onClick(index)}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: '#fff',
        borderRadius: 16,
        overflow: 'hidden',
        cursor: 'pointer',
        border: `1px solid ${hov ? '#d4cfc8' : '#ede9e3'}`,
        boxShadow: hov ? '0 12px 32px rgba(0,0,0,0.10)' : '0 2px 8px rgba(0,0,0,0.04)',
        transform: hov ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'all 0.25s ease',
      }}
    >
      {/* Thumbnail */}
      <div style={{ position: 'relative', aspectRatio: '16/9', background: '#f0ede8', overflow: 'hidden' }}>
        <video
          src={src}
          preload="metadata"
          muted
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />

        {/* Hover overlay */}
        <div
          style={{
            position: 'absolute', inset: 0,
            background: hov ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.08)',
            transition: 'background 0.25s ease',
          }}
        />

        {/* Play button */}
        <div
          style={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            opacity: hov ? 1 : 0.7,
            transition: 'opacity 0.25s ease',
          }}
        >
          <div
            style={{
              width: hov ? 52 : 44,
              height: hov ? 52 : 44,
              borderRadius: '50%',
              background: hov ? '#fff' : 'rgba(255,255,255,0.85)',
              boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'all 0.25s ease',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#1a1a1a">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>

        {/* Index badge */}
        <div
          style={{
            position: 'absolute', top: 10, left: 12,
            background: 'rgba(255,255,255,0.88)',
            backdropFilter: 'blur(6px)',
            borderRadius: 20, padding: '2px 9px',
            fontSize: 10, color: '#666',
            letterSpacing: 1.5, fontWeight: 600,
          }}
        >
          {String(index + 1).padStart(2, '0')}
        </div>

        {/* Year badge */}
        <div
          style={{
            position: 'absolute', top: 10, right: 12,
            background: is2026 ? '#EEEdFF' : '#FDF0E8',
            borderRadius: 20, padding: '2px 10px',
            fontSize: 10, color: is2026 ? '#5B4FCF' : '#C4903A',
            fontWeight: 700, letterSpacing: 0.5,
          }}
        >
          {video.year}
        </div>
      </div>

      {/* Title */}
      <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontFamily: 'DM Serif Display', fontSize: 15, color: '#1a1a1a', lineHeight: 1.4 }}>
          {video.title}
        </div>
        <div
          style={{
            width: 28, height: 28, borderRadius: '50%',
            background: hov ? '#f0ede8' : 'transparent',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, transition: 'background 0.2s',
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={hov ? '#1a1a1a' : '#bbb'} strokeWidth="2.5" style={{ transition: 'stroke 0.2s' }}>
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function VideoLightbox({ index, onClose, onPrev, onNext }) {
  const video = VIDEOS[index];
  const src = video.src || `/Event%20Coverage/${encodeURIComponent(video.file)}`;
  const videoRef = useRef(null);
  const is2026 = video.year === '2026';

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    if (videoRef.current) videoRef.current.load();
  }, [index]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(26,26,26,0.85)',
        backdropFilter: 'blur(10px)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '2rem',
        animation: 'fadeIn 0.2s ease',
      }}
    >
      {/* Modal panel */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: 20,
          overflow: 'hidden',
          width: '100%', maxWidth: 900,
          boxShadow: '0 32px 80px rgba(0,0,0,0.4)',
        }}
      >
        {/* Modal header */}
        <div
          style={{
            padding: '18px 24px',
            borderBottom: '1px solid #ede9e3',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ fontFamily: 'DM Serif Display', fontSize: 18, color: '#1a1a1a' }}>
              {video.title}
            </div>
            <span
              style={{
                fontSize: 10, fontWeight: 700, letterSpacing: 0.5,
                background: is2026 ? '#EEEdFF' : '#FDF0E8',
                color: is2026 ? '#5B4FCF' : '#C4903A',
                borderRadius: 20, padding: '3px 10px',
              }}
            >
              {video.year}
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ fontSize: 12, color: '#aaa' }}>
              {index + 1} / {VIDEOS.length}
            </div>
            <button
              onClick={onClose}
              style={{
                background: '#f5f3f0', border: '1px solid #e8e4e0',
                borderRadius: '50%', width: 32, height: 32,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 16, color: '#666', cursor: 'pointer',
              }}
            >
              ×
            </button>
          </div>
        </div>

        {/* Video */}
        <div style={{ background: '#1a1a1a' }}>
          <video
            ref={videoRef}
            src={src}
            controls
            autoPlay
            preload="auto"
            style={{ width: '100%', display: 'block', maxHeight: '65vh' }}
          />
        </div>

        {/* Modal footer — prev / next */}
        <div
          style={{
            padding: '14px 24px',
            borderTop: '1px solid #ede9e3',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}
        >
          <button
            onClick={onPrev}
            disabled={index === 0}
            style={{
              background: index === 0 ? 'transparent' : '#f5f3f0',
              border: '1px solid #e8e4e0',
              borderRadius: 8, padding: '7px 18px',
              fontSize: 13, color: index === 0 ? '#ccc' : '#444',
              cursor: index === 0 ? 'not-allowed' : 'pointer',
            }}
          >
            ← Prev
          </button>

          <div style={{ display: 'flex', gap: 6 }}>
            {VIDEOS.map((_, i) => (
              <div
                key={i}
                style={{
                  width: i === index ? 20 : 6,
                  height: 6, borderRadius: 3,
                  background: i === index ? '#1a1a1a' : '#e8e4e0',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (i < index) onPrev();
                  else if (i > index) onNext();
                }}
              />
            ))}
          </div>

          <button
            onClick={onNext}
            disabled={index === VIDEOS.length - 1}
            style={{
              background: index === VIDEOS.length - 1 ? 'transparent' : '#1a1a1a',
              border: index === VIDEOS.length - 1 ? '1px solid #e8e4e0' : 'none',
              borderRadius: 8, padding: '7px 18px',
              fontSize: 13, color: index === VIDEOS.length - 1 ? '#ccc' : '#fff',
              cursor: index === VIDEOS.length - 1 ? 'not-allowed' : 'pointer',
            }}
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  );
}

function EventCoveragePage({ onBack, user, onLogout }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const initials = user.name.slice(0, 2).toUpperCase();
  const count2025 = VIDEOS.filter(v => v.year === '2025').length;
  const count2026 = VIDEOS.filter(v => v.year === '2026').length;

  return (
    <div style={{ minHeight: '100vh', background: '#F7F5F2' }}>

      {/* ── Header — identical to other pages ── */}
      <header
        style={{
          background: '#fff',
          borderBottom: '1px solid #ede9e3',
          padding: '0 2.5rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          height: 116, position: 'sticky', top: 0, zIndex: 100,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="ChalkWalk Design Studio" style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <button
            onClick={onBack}
            style={{ background: '#f5f3f0', border: '1px solid #e8e4e0', borderRadius: 8, padding: '6px 16px', fontSize: 13, color: '#666', cursor: 'pointer' }}
          >
            ← Back to Planner
          </button>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>{user.name}</div>
            <div style={{ fontSize: 11, color: '#aaa' }}>{user.email}</div>
          </div>
          <div
            style={{
              width: 36, height: 36, background: '#5B4FCF', borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 13, fontWeight: 600, color: '#fff',
            }}
          >
            {initials}
          </div>
          <button
            onClick={onLogout}
            style={{ background: '#f5f3f0', border: '1px solid #e8e4e0', borderRadius: 8, padding: '6px 14px', fontSize: 12, color: '#666', cursor: 'pointer' }}
          >
            Sign Out
          </button>
        </div>
      </header>

      {/* ── Main ── */}
      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '2.5rem 2rem' }}>

        {/* Page title */}
        <div style={{ marginBottom: '2.5rem', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
          <div>
            <h1 style={{ fontFamily: 'DM Serif Display', fontSize: 36, color: '#1a1a1a', marginBottom: 6 }}>
              Event Coverage
            </h1>
            <p style={{ color: '#888', fontSize: 14 }}>
              {VIDEOS.length} exhibition highlight{VIDEOS.length !== 1 ? 's' : ''} from ChalkWalk Design Studio
            </p>
          </div>

          {/* Year filter chips */}
          <div style={{ display: 'flex', gap: 8 }}>
            <div
              style={{
                background: '#FDF0E8', borderRadius: 20, padding: '5px 14px',
                fontSize: 12, color: '#C4903A', fontWeight: 600,
                border: '1px solid #f5ddb8',
              }}
            >
              {count2025} · 2025
            </div>
            <div
              style={{
                background: '#EEEdFF', borderRadius: 20, padding: '5px 14px',
                fontSize: 12, color: '#5B4FCF', fontWeight: 600,
                border: '1px solid #d4d0f5',
              }}
            >
              {count2026} · 2026
            </div>
          </div>
        </div>

        {/* Video grid */}
        <div
          className="fade-in"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: 20,
          }}
        >
          {VIDEOS.map((v, i) => (
            <VideoCard key={v.file} video={v} index={i} onClick={setActiveIndex} />
          ))}
        </div>
      </main>

      {/* ── Lightbox ── */}
      {activeIndex !== null && (
        <VideoLightbox
          index={activeIndex}
          onClose={() => setActiveIndex(null)}
          onPrev={() => setActiveIndex(i => Math.max(0, i - 1))}
          onNext={() => setActiveIndex(i => Math.min(VIDEOS.length - 1, i + 1))}
        />
      )}
    </div>
  );
}

export default EventCoveragePage;
